import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import ApiKeyDisplay from '../api-key-display';
import RoleDisplay from '../role-display';
type UpdateOrgApiKeyRoleProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const UpdateOrgApiKeyRole = t0 => {
  const $ = _c(31);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.update"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "update_org_api_key_role") {
    return null;
  }
  const {
    apiKey,
    oldRole,
    newRole
  } = detail.data;
  let t2;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t2 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== apiKey.name || $[7] !== apiKey.role.name || $[8] !== apiKey.role.scopes) {
    t4 = <ApiKeyDisplay name={apiKey.name} scopes={apiKey.role.scopes} roleName={apiKey.role.name} />;
    $[6] = apiKey.name;
    $[7] = apiKey.role.name;
    $[8] = apiKey.role.scopes;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp3);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <span className="text-body-2 text-tertiary">{t5}</span>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== oldRole.name || $[15] !== oldRole.scopes) {
    t7 = <RoleDisplay name={oldRole.name} scopes={oldRole.scopes} />;
    $[14] = oldRole.name;
    $[15] = oldRole.scopes;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp4);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <span className="text-body-2 text-tertiary">{t8}</span>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== newRole.name || $[22] !== newRole.scopes) {
    t10 = <RoleDisplay name={newRole.name} scopes={newRole.scopes} />;
    $[21] = newRole.name;
    $[22] = newRole.scopes;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t3 || $[26] !== t4 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9) {
    t11 = <>{t3}{t4}{t6}{t7}{t9}{t10}</>;
    $[24] = t10;
    $[25] = t3;
    $[26] = t4;
    $[27] = t6;
    $[28] = t7;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
export default UpdateOrgApiKeyRole;
function _temp($) {
  return $.updated;
}
function _temp2($_0) {
  return $_0.updated;
}
function _temp3($_1) {
  return $_1.from;
}
function _temp4($_2) {
  return $_2.to;
}